import React, { createContext, useState, useEffect, useContext } from 'react';
import commonApi from '../utils/api';
import { CommonContext } from './CommonContext';
import moment from 'moment/moment';
import { useNavigate } from 'react-router-dom';

export const DashboardContext = createContext();

export function DashboardContextProvider({ children }) {
    const { user } = useContext(CommonContext);
    const [addModal, setAddModal] = useState(false);
    const [allData, setAllData] = useState({});
    const [allPandingSummary, setAllPandingSummary] = useState([]);
    const [allPickupPandingSummary, setAllPickupPandingSummary] = useState([]);
    const [allNotattemptedSummary, setAllNotattemptedSummary] = useState([]);
    const [allB2CUser, setAllB2CUser] = useState({});
    const [allDownload, setAllDownload] = useState([]);
    const [viewData, setViewData] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [firstPLoading, setFirstPLoading] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [firstNALoading, setFirstNALoading] = useState(false);
    const [firstPPLoading, setFirstPPLoading] = useState(false);
    const [fStartDate, setFStartDate] = useState(null);
    const [fEndDate, setFEndDate] = useState(null);
    const defaultStartDate = moment().startOf('month');
    const defaultEndDate = moment().endOf('month');
    const defaultDateRange = [defaultStartDate.toDate(), defaultEndDate.toDate()];
    const [fDateRange, setFDateRange] = useState(defaultDateRange);
    const [selectedCourierIds, setSelectedCourierIds] = useState([]);
    const [selectedMerchantIds, setSelectedMerchantIds] = useState([]);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMesaage, setAlertMesaage] = useState('');
    const [severity, setSeverity] = useState('');
    const [filters, setFilters] = useState({
        user_id: [],
        dateRange: null,
    });
    const navigate = useNavigate();
    const onCloseAlert = () => {
        setOpenAlert(false);
        setAlertMesaage('');
        setSeverity('')
    };
    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setAddModal(false);
    };

    const onLoadApi = () => {
        setFDateRange(defaultDateRange);
        setSelectedCourierIds([]);
        setSelectedMerchantIds([]);
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq = { merchant_id: user?.id, start_date: defaultStartDate.format('YYYY-MM-DD'), end_date: defaultEndDate.format('YYYY-MM-DD') }
        } else {
            postReq = { start_date: defaultStartDate.format('YYYY-MM-DD'), end_date: defaultEndDate.format('YYYY-MM-DD') }
        }
        setFirstLoading(false);
        commonApi.post('/admin/dashboard', postReq)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    // setAllDownload(response?.data?.data);
                    setAllData(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };
    const onB2CUserApi = (filter) => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        if (filter?.user_id) {
            postReq.user_id = filter?.user_id
        } else {
            postReq.user_id = []
        }
        if (filter?.service_type) {
            postReq.service_type = filter?.service_type
        } else {
            postReq.service_type = '1'
        }
        if (filter?.dateRange) {
            postReq.start_date = filter?.dateRange[0] ? moment(filter?.dateRange[0]).format('YYYY-MM-DD') : ''
            postReq.end_date = filter?.dateRange[1] ? moment(filter?.dateRange[1]).format('YYYY-MM-DD') : ''
        } else {
            postReq.start_date = moment().startOf('month').format('YYYY-MM-DD')
            postReq.end_date = moment().endOf('month').format('YYYY-MM-DD')
            const dDateRange = [moment().startOf('month').toDate(), moment().endOf('month').toDate()];
            setFilters({ ...filters, dateRange: dDateRange });
        }
        setFirstLoading(false);
        commonApi.post('/admin/b2c-user-dashboard', postReq)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.s === 1) {
                    // setAllDownload(response?.data?.data);
                    // console.log('response?.data?.data', response?.data?.data);
                    setAllB2CUser(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };
    const onFilter = () => {
        setIsLoading(true);
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq = { merchant_id: user?.id, start_date: fStartDate ? moment(fStartDate).format('YYYY-MM-DD') : defaultStartDate.format('YYYY-MM-DD'), end_date: fEndDate ? moment(fEndDate).format('YYYY-MM-DD') : defaultEndDate.format('YYYY-MM-DD') }
        } else {
            postReq = { start_date: fStartDate ? moment(fStartDate).format('YYYY-MM-DD') : defaultStartDate.format('YYYY-MM-DD'), end_date: fEndDate ? moment(fEndDate).format('YYYY-MM-DD') : defaultEndDate.format('YYYY-MM-DD') }
        }
        if (selectedCourierIds.length > 0) {
            postReq.courier_id = selectedCourierIds
        }
        if (selectedMerchantIds.length > 0) {
            postReq.merchant_id = selectedMerchantIds
        }
        commonApi.post('/admin/dashboard', postReq)
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.data) {
                    // setAllDownload(response?.data?.data);
                    setAllData(response?.data?.data);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onPendingLoadApi = (pendingFilter) => {
        setAllPandingSummary([]);
        let postReq = { ...pendingFilter };
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        setFirstPLoading(false);
        commonApi.post('/admin/b2c-pending-summary', postReq)
            .then((response) => {
                setFirstPLoading(true);
                if (response?.data?.data) {
                    // setAllDownload(response?.data?.data);
                    setAllPandingSummary(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstPLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    const onPickupPendingLoadApi = (pickupPendingFilter) => {
        let postReq = { ...pickupPendingFilter };
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        setFirstPPLoading(false);
        commonApi.post('/admin/b2c-pickup-pending-summary', postReq)
            .then((response) => {
                setFirstPPLoading(true);
                if (response?.data?.data) {
                    // setAllDownload(response?.data?.data);
                    setAllPickupPandingSummary(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstPPLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    const onNotattemptedLoadApi = (notAttemptedFilter) => {
        let postReq = { ...notAttemptedFilter };
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        setFirstNALoading(false);
        commonApi.post('/admin/b2c-not-attempted-shipments', postReq)
            .then((response) => {
                setFirstNALoading(true);
                if (response?.data?.data) {
                    // setAllDownload(response?.data?.data);
                    setAllNotattemptedSummary(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstNALoading(true);
                console.error('Error fetching data:', error);
            });
    };


    const onPendingExport = (courierId = null, day = null) => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        if (courierId) {
            postReq.courier_id = courierId;
        }
        if (day > 0 && day <= 45) {
            const date = moment().subtract(day - 1, 'days').format('YYYY-MM-DD');
            postReq.date = date;
        }
        if (day === '45+') {
            const date = moment().subtract(45, 'days').format('YYYY-MM-DD');
            postReq.date = date;
            postReq.is_from = 1
        }
        setOpenAlert(false);
        setAlertMesaage('');
        setSeverity('');
        setIsLoading(true);
        commonApi.post('/admin/b2c-pending-summary/export', postReq)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMesaage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMesaage(response?.data?.msg);
                    setSeverity('success');
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setAlertMesaage(error?.response?.data?.msg || error?.message || 'Error fetching data');
                setSeverity('error');
                setOpenAlert(true);
                console.error('Error fetching data:', error);
            });
    };
    const onPickupPendingExport = (merchatId = null, courierId = null, day = null) => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        if (merchatId) {
            postReq.merchant_id = merchatId;
        }
        if (courierId) {
            postReq.courier_id = courierId;
        }
        if (day > 0 && day <= 45) {
            const date = moment().subtract(day - 1, 'days').format('YYYY-MM-DD');
            postReq.date = date;
        }
        if (day === '10+') {
            const date = moment().subtract(10, 'days').format('YYYY-MM-DD');
            postReq.date = date;
            postReq.is_from = 1
        }
        setOpenAlert(false);
        setAlertMesaage('');
        setSeverity('');
        setIsLoading(true);
        commonApi.post('/admin/b2c-pickup-pending-summary/export', postReq)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMesaage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMesaage(response?.data?.msg);
                    setSeverity('success');
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setAlertMesaage(error?.response?.data?.msg || error?.message || 'Error fetching data');
                setSeverity('error');
                setOpenAlert(true);
                console.error('Error fetching data:', error);
            });
    };
    const onNotattemptedExport = (zoneId = null, day = null) => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        if (zoneId) {
            postReq.zone_category_id = zoneId;
        }
        if (day > 0 && day <= 45) {
            const date = moment().subtract(day - 1, 'days').format('YYYY-MM-DD');
            postReq.date = date;
        }
        if (day === '10+') {
            const date = moment().subtract(10, 'days').format('YYYY-MM-DD');
            postReq.date = date;
            postReq.is_from = 1
        }
        setOpenAlert(false);
        setAlertMesaage('');
        setSeverity('');
        setIsLoading(true);
        commonApi.post('/admin/b2c-not-attempted-shipments/export', postReq)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMesaage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMesaage(response?.data?.msg);
                    setSeverity('success');
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setAlertMesaage(error?.response?.data?.msg || error?.message || 'Error fetching data');
                setSeverity('error');
                setOpenAlert(true);
                console.error('Error fetching data:', error);
            });
    };
    useEffect(() => {
        onLoadApi();
        // onPendingLoadApi();
        // onPickupPendingLoadApi();
        // onNotattemptedLoadApi();
    }, []);

    // You can provide any values or functions you want to make available to consumers here
    const contextValue = {
        onNotattemptedExport,
        onPendingExport,
        onPickupPendingExport,
        openAlert,
        setOpenAlert,
        alertMesaage,
        setAlertMesaage,
        severity,
        setSeverity,
        onCloseAlert,
        firstNALoading,
        onNotattemptedLoadApi,
        firstPPLoading,
        onPickupPendingLoadApi,
        firstPLoading,
        onPendingLoadApi,
        allNotattemptedSummary,
        allPickupPandingSummary,
        allPandingSummary,
        filters,
        setFilters,
        onB2CUserApi,
        allB2CUser,
        selectedCourierIds,
        selectedMerchantIds,
        setSelectedCourierIds,
        setSelectedMerchantIds,
        onFilter,
        fDateRange,
        fStartDate,
        fEndDate,
        onLoadApi,
        isLoading,
        firstLoading,
        viewData,
        allDownload,
        allData,
        handleAddModal,
        handleCloseModal,
        setAddModal,
        addModal,
        setAllData,
        setAllDownload,
        setViewData,
        setFirstLoading,
        setIsLoading,
        setFEndDate,
        setFStartDate,
        setFDateRange,
    };

    // Render the provider with children
    return <DashboardContext.Provider value={contextValue}>{children}</DashboardContext.Provider>;
}
